import React from "react";
import { BaseIconProps } from "../../types/styles";

const OIcon = ({
    id,
    className,
    size = 30,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--neutral-500)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-circle-o"}
            className={className}
            height={size}
            width={size}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path
                fill={color}
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
            />
        </svg>
    );
};

export default OIcon;
